import { Component, OnInit, inject ,Inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AmplifyUser } from '@aws-amplify/ui';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { ConfigService } from 'src/app/config.service';
import { AuthService } from 'src/app/services/auth.service';
import { TUI_IS_MOBILE } from "@taiga-ui/cdk";
import { Auth } from 'aws-amplify';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { VerifyNumberComponent } from './verify-number/verify-number.component';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { VerificationNumberAttempt } from 'src/models/extra';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
})
export class MyProfileComponent implements OnInit {
  
  
  user!: AmplifyUser;
  //authenticatorSvc = inject(AuthenticatorService);
  //auth = inject(AuthService);
  lambda = inject(AWSLambda);
  dialog = inject(MatDialog);
  transfersUrl = `${inject(ConfigService).config.transfersUrl}?tracker=${inject(AuthService).getUser().id}`;
  name: string | undefined;
  phone_number: string | undefined;
  email: string | undefined;

  middle_name: string | undefined;
  address: string | undefined;
  country: string | undefined;

  ciudad: string | undefined;
  provincia: string | undefined;
  postcode: string | undefined;
  passport: string | undefined;

  signalwire_verified_phone_number: boolean | undefined;
  phone_number_verified= false ;
  isVerificationInProgress = false;
  isLoadingVerification = true;

  constructor(
    @Inject(TUI_IS_MOBILE) public mobile: boolean,
    private authenticatorSvc: AuthenticatorService,
    private auth: AuthService,
    private router: Router
      ) {
      
      }

  async ngOnInit() {
    // Pre-populate immediately from cached auth state — no async wait
    const cached = this.auth.getUser();
    if (cached.loggedIn) {
      this.name = (cached.name && cached.name !== ' ')
        ? [cached.name, cached.middle_name].filter(Boolean).join(' ')
        : '';
      this.phone_number = cached.phone_number ?? undefined;
      this.email = cached.email ?? undefined;

      // If verification status is already cached, show it immediately
      if (cached.phone_number_verified !== undefined) {
        this.phone_number_verified = cached.phone_number_verified;
        this.signalwire_verified_phone_number = cached.phone_number_verified;
        this.isLoadingVerification = false;
      }
    }

    // Refresh Cognito data (also picks up changes made in edit-profile)
    await this.auth.refresh();
    try {
      this.user = await Auth.currentAuthenticatedUser();
      this.lambda.getLambdaFunction("lambda", "/get/userDetails").then((data) => {
        this.auth.setUserDetails(data);
        this.ciudad = data['custom:ciudad'];
        this.provincia = data['custom:provincia'];
        this.postcode = data['custom:postcode'];
        this.passport = data['custom:passport'];
      });

      if (this.user.attributes?.['name'] == undefined || this.user.attributes?.['name'] == ' ') this.name = ''; else this.name = this.user.attributes?.['name'] + ' ' + this.user.attributes?.['middle_name'];
      if (this.user.attributes?.['phone_number'] != undefined) this.phone_number = this.user.attributes?.['phone_number'];
      if (this.user.attributes?.['email'] != undefined) this.email = this.user.attributes?.['email'];

      if (this.user.attributes?.['middle_name'] != undefined) this.middle_name = this.user.attributes?.['middle_name'];
      if (this.user.attributes?.['custom:address'] != undefined) this.address = this.user.attributes?.['custom:address'];
      if (this.user.attributes?.['custom:country'] != undefined) this.country = this.user.attributes?.['custom:country'];

      this.phone_number_verified = this.user.attributes?.['phone_number_verified'] === 'true';
      const attributesJson = JSON.stringify(this.user.attributes);
      const objJson = JSON.parse(attributesJson);

      this.signalwire_verified_phone_number = objJson['phone_number_verified'];
      this.isLoadingVerification = false;
    } catch (error) {
      this.auth.logout();
    }
  }

  openModal() {
    this.dialog
      .open(DeleteAccountComponent)
      .afterClosed()
      .subscribe((confirm: Boolean) => {
        if (confirm) {
          this.auth.deleteAccount();
        }
      });
  }

  openVerification() {
    // Send an code to Signalwire
    console.log(this.user.attributes)
    this.isVerificationInProgress = true;
    this.lambda.getLambdaFunction("lambda", "/aws/verification/send", {
      queryStringParameters: { phone_number: this.user.attributes?.phone_number, lang: this.user.attributes?.['locale'] ? this.user.attributes?.['locale'] : 'es' },
    }).then( (data) => {
        this.dialog
          .open(VerifyNumberComponent, {
            data: Object.assign({}, data, { phone_number: this.user.attributes?.phone_number })
          })
          .afterClosed()
          .subscribe(() => {
            // Recargar la página después de que el diálogo se haya cerrado
            window.location.reload();
          });
    }).catch( () => {
      // Error
    }).finally(() => {
      // Habilitar el botón de nuevo después de que se complete la operación
      this.isVerificationInProgress = false;
    });
  } 
  
}
